<template>
  <VuePerfectScrollbar class="gm-legacy-automation">
    <div class="p-6 gm-legacy-automation__body">
      <div class="w-full">
        <div class="flex flex-col mb-6 gm-legacy-automation__name-field">
          <label class="font-semibold text-sm text-grey-700 mb-2">
            {{ $t('frontend_groovemail_analytics_list_automation_name') }}
          </label>
          <text-input
            class="gm-legacy-automation__name-input"
            variant="base"
            v-model="localModel.name"
            :placeholder="$t('frontend_groovemail_adminsetting_name')"
            :validator="$v.localModel.name"
          />
        </div>
        <div class="font-semibold text-grey-800 text-lg text-center mb-2 gm-legacy-automation__heading">
          {{ $t('frontend_groovemail_analytics_list_if') }}
        </div>
        <div class="flex flex-col w-full border-grey-300 border-b gm-legacy-automation__rule-section">
          <div class="flex pb-4 gm-legacy-automation__choice-row">
            <div class="flex flex-1 gm-legacy-automation__choice-controls">
              <div class="w-5/12 pr-2">
                <select
                  v-model="localModel.pre_mainselect"
                  class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                  @change="changepreselect($event)"
                >
                  <option value="">
                    {{
                      this.localModel.prefields.length > 0
                        ? $t('frontend_groovemail_automations_select_condition')
                        : $t('frontend_groovemail_automations_trigger_select')
                    }}
                  </option>
                  <option
                    v-for="trigger in this.triggers"
                    :key="trigger.value"
                    :value="trigger.value"
                    :data-type="trigger.dataType"
                    :data-operation="trigger.operation"
                  >
                    {{ trigger.value }}
                  </option>
                </select>
              </div>
              <div
                v-if="
                  localModel.pre_mainselect ==
                    $t(
                      'frontend_automations_trigger_lead_is_subscribed_to_list'
                    ) ||
                    localModel.pre_mainselect ==
                      $t(
                        'frontend_automations_trigger_lead_is_not_subscribed_to_list'
                      ) ||
                    localModel.pre_mainselect ==
                      $t(
                        'frontend_groovemail_sequences_startingrules_lead_subscribers'
                      ) ||
                    localModel.pre_mainselect ==
                      $t(
                        'frontend_automations_trigger_lead_unsubscribes_from_list'
                      )
                "
                class="w-7/12 pr-2"
              >
                <select
                  v-model="localModel.predata"
                  class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                  @change="assignprename($event)"
                >
                  <option value="">
                    {{ $t('frontend_automations_select_list') }}
                  </option>
                  <option
                    v-for="list in this.pre_lists"
                    :key="list.id"
                    :value="list.id"
                    :data-name="list.name"
                  >
                    {{ list.name }}
                  </option>
                </select>
              </div>
              <div
                v-else-if="
                  localModel.pre_mainselect ==
                    $t(
                      'frontend_automations_trigger_lead_subscribes_to_sequence'
                    ) ||
                    localModel.pre_mainselect ==
                      $t(
                        'frontend_automations_trigger_lead_is_subscribed_to_sequence'
                      )
                "
                class="w-7/12 pr-2"
              >
                <select
                  v-model="localModel.predata"
                  class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                  @change="assignprename($event)"
                >
                  <option value="">
                    {{ $t('frontend_automations_select_sequence') }}
                  </option>
                  <option
                    v-for="sequence in this.pre_sequences"
                    :key="sequence.id"
                    :value="sequence.id"
                    :data-name="sequence.name"
                  >
                    {{ sequence.name }}
                  </option>
                </select>
              </div>
              <div
                v-else-if="
                  localModel.pre_mainselect ==
                    $t('frontend_automations_trigger_lead_has_filled_form') ||
                    localModel.pre_mainselect ==
                      $t('frontend_automations_trigger_lead_fills_form')
                "
                class="w-7/12 pr-2"
              >
                <select
                  v-model="localModel.predata"
                  class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                  @change="assignprename($event)"
                >
                  <option value="">
                    {{ $t('frontend_automations_select_form') }}
                  </option>
                  <option
                    v-for="form in this.pre_forms"
                    :key="form.id"
                    :value="form.id"
                    :data-name="form.name"
                  >
                    {{ form.name }}
                  </option>
                </select>
              </div>
              <div
                v-else-if="
                  localModel.pre_mainselect ==
                    $t('frontend_automations_trigger_lead_has_tag') ||
                    localModel.pre_mainselect ==
                      $t(
                        'frontend_automations_trigger_lead_does_not_have_tag'
                      ) ||
                    localModel.pre_mainselect ==
                      $t('frontend_groovemail_sequences_startingrules_leadis')
                "
                class="w-7/12 pr-2"
              >
                <div class="flex">
                  <div class="w-1/2 pr-2">
                    <select
                      class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                      @change="precategory($event)"
                    >
                      <option value="">
                        {{ $t('frontend_automations_select_category') }}
                      </option>
                      <option
                        v-for="category in this.pre_categories"
                        :key="category.id"
                        :value="category.id"
                      >
                        {{ category.name }}
                      </option>
                    </select>
                  </div>
                  <div class="w-1/2">
                    <select
                      v-model="localModel.predata"
                      class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                      @change="assignprename($event)"
                    >
                      <option value="">
                        {{ $t('frontend_automations_select_tag') }}
                      </option>
                      <option
                        v-for="tag in this.pre_tags"
                        :key="tag.id"
                        :value="tag.id"
                        :data-name="tag.name"
                      >
                        {{ tag.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div
                v-else-if="
                  localModel.pre_mainselect == $t(
                    'frontend_groovemail_leads_filter_opened_a_broadcast_option'
                  ) ||
                  localModel.pre_mainselect == $t(
                    'frontend_groovemail_leads_filter_clicked_a_link_option'
                  )
                "
                class="w-7/12 flex pr-2"
              >
                <select
                  v-model="localModel.broadcast_id"
                  class="
                    text-sm
                    rounded
                    mr-2
                    bg-white
                    border
                    border-grey-300
                    text-grey-700
                    py-2 px-2 pr-6
                  "
                  :class="{
                    'w-6/12': localModel.pre_mainselect == $t('frontend_groovemail_leads_filter_clicked_a_link_option'),
                    'w-full': localModel.pre_mainselect == $t('frontend_groovemail_leads_filter_opened_a_broadcast_option')
                  }"
                  @change="assignBroadcastId($event)"
                >
                  <option value="">
                    {{ $t('frontend_groovemail_automations_trigger_select_broadcast_label') }}
                  </option>
                  <option
                    v-for="broadcast in this.broadcasts"
                    :key="broadcast.id"
                    :value="broadcast.id"
                    :data-name="broadcast.name"
                  >
                    {{ broadcast.name }}
                  </option>
                </select>

                <select
                  v-if="
                    localModel.pre_mainselect == $t('frontend_groovemail_leads_filter_clicked_a_link_option')
                  "
                  v-model="localModel.broadcast_link_id"
                  class="
                    text-sm
                    rounded
                    w-6/12
                    mr-2
                    bg-white
                    border
                    border-grey-300
                    text-grey-700
                    py-2 px-2 pr-6
                  "
                  @change="assignBroadcastLinkId($event)"
                >
                  <option value="">
                    {{ $t('frontend_groovemail_automations_trigger_link_any_link_label') }}
                  </option>
                  <option
                    v-for="link in this.broadcastLinks"
                    :key="link.id"
                    :value="link.id"
                    :data-name="link.redirect_url"
                  >
                    {{ link.redirect_url }}
                  </option>
                </select>
              </div>
              <div
                v-else-if="
                  localModel.pre_mainselect == $t(
                    'frontend_groovemail_automations_trigger_opened_email_from_sequence'
                  ) ||
                  localModel.pre_mainselect == $t(
                    'frontend_groovemail_automations_trigger_clicked_link_in_email_from_sequence'
                  )
                "
                class="w-7/12 flex pr-2"
              >
                <select
                  v-model="localModel.sequence_id"
                  class="
                    text-sm
                    rounded
                    mr-2
                    bg-white
                    border
                    border-grey-300
                    text-grey-700
                    py-2 px-2 pr-6
                  "
                  :class="{
                    'w-4/12': localModel.pre_mainselect == $t('frontend_groovemail_automations_trigger_clicked_link_in_email_from_sequence'),
                    'w-6/12': localModel.pre_mainselect == $t('frontend_groovemail_automations_trigger_opened_email_from_sequence')
                  }"
                  @change="assignSequenceId($event)"
                >
                  <option value="">
                    {{ $t('frontend_automations_select_sequence') }}
                  </option>
                  <option
                    v-for="sequence in this.sequences"
                    :key="sequence.id"
                    :value="sequence.id"
                    :data-name="sequence.name"
                  >
                    {{ sequence.name }}
                  </option>
                </select>

                <select
                  v-model="localModel.email_node_id"
                  class="
                    text-sm
                    rounded
                    mr-2
                    bg-white
                    border
                    border-grey-300
                    text-grey-700
                    py-2 px-2 pr-6
                  "
                  :class="{
                    'w-4/12': localModel.pre_mainselect == $t('frontend_groovemail_automations_trigger_clicked_link_in_email_from_sequence'),
                    'w-6/12': localModel.pre_mainselect == $t('frontend_groovemail_automations_trigger_opened_email_from_sequence')
                  }"
                  @change="assignEmailNodeId($event)"
                >
                  <option value="">
                    {{ $t('frontend_groovemail_automations_trigger_link_any_email_node_label') }}
                  </option>
                  <option
                    v-for="emailNode in this.emailNodes"
                    :key="emailNode.id"
                    :value="emailNode.id"
                    :data-name="emailNode.name"
                  >
                    {{ emailNode.name }}
                  </option>
                </select>

                <select
                  v-if="
                    localModel.pre_mainselect == $t('frontend_groovemail_automations_trigger_clicked_link_in_email_from_sequence')
                  "
                  v-model="localModel.sequence_email_node_link_id"
                  class="
                    text-sm
                    rounded
                    w-4/12
                    mr-2
                    bg-white
                    border
                    border-grey-300
                    text-grey-700
                    py-2 px-2 pr-6
                  "
                  @change="assignSequenceEmailLinkId($event)"
                >
                  <option value="">
                    {{ $t('frontend_groovemail_automations_trigger_link_any_link_label') }}
                  </option>
                  <option
                    v-for="link in this.sequenceEmailLinks"
                    :key="link.id"
                    :value="link.id"
                    :data-name="link.redirect_url"
                  >
                    {{ link.redirect_url }}
                  </option>
                </select>
              </div>
              <div
                v-else-if="
                  localModel.pre_mainselect == $t(
                    'frontend_automations_trigger_lead_purchased_a_product'
                  ) ||
                  localModel.pre_mainselect == $t(
                    'frontend_groovemail_automations_trigger_abandon_cart'
                  ) ||
                  localModel.pre_mainselect == $t(
                    'frontend_automations_trigger_lead_refunded_a_product'
                  ) ||
                  localModel.pre_mainselect == $t(
                    'frontend_automations_trigger_lead_cancel_a_subscription'
                  )
                "
                class="w-7/12 flex pr-2"
              >
                <select
                  v-model="localModel.funnelid"
                  class="text-sm rounded w-4/12 mr-2 bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                  @change="assignfunnelid($event)"
                >
                  <option value="">
                    {{ $t('frontend_automations_select_funnel') }}
                  </option>
                  <option
                    v-for="funnel in this.pre_funnels"
                    :key="funnel.id"
                    :value="funnel.id"
                    :data-name="funnel.name"
                  >
                    {{ funnel.name }}
                  </option>
                </select>

                <select
                  v-model="localModel.productid"
                  class="text-sm rounded w-4/12 mr-2 bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                  @change="assignproductid($event)"
                >
                  <option value="">
                    {{ $t('frontend_automations_select_any_product') }}
                  </option>
                  <option
                    v-for="product in this.pre_products"
                    :key="product.id"
                    :value="product.id"
                    :data-name="product.name"
                  >
                    {{ product.name }}
                  </option>
                </select>

                <select
                  v-model="localModel.pricepointid"
                  class="text-sm rounded w-4/12 bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                  @change="assignpricepointid($event)"
                >
                  <option value="">
                    {{ $t('frontend_automations_select_any_price_point') }}
                  </option>
                  <option
                    v-for="pricePoint in this.pre_price_points"
                    :key="pricePoint.id"
                    :value="pricePoint.id"
                    :data-name="pricePoint.name"
                  >
                    {{ pricePoint.name }}
                  </option>
                </select>
              </div>
              <div v-else class="w-7/12 pr-2">
                <select
                  class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                >
                  <option value="">{{ $t('frontend_select') }}</option>
                </select>
              </div>
            </div>
            <div class="gm-legacy-automation__choice-add">
              <gd-button
                variant="primary"
                size="icon"
                class="h-10 w-10 gm-legacy-automation__add-rule"
                :disabled="!localModel.predata"
                @click="localModel.predata != '' ? addprefield() : null"
              >
                <PlusIcon class="h-7 w-7" />
              </gd-button>
            </div>
          </div>
          <div class="flex mb-4 gm-legacy-automation__rule-list">
            <div class="w-full">
              <div class="flex flex-wrap items-center gm-legacy-automation__rule-items">
                <div
                  v-for="option in this.localModel.prefields"
                  :key="JSON.stringify(option.id)"
                  class="flex items-center gm-legacy-automation__rule-item"
                >
                  <div
                    class="flex flex-row rounded px-2 py-1 font-semibold text-primary-invert text-xs bg-primary gm-legacy-automation__rule-chip"
                  >
                    {{ option.action }}
                    <span class="font-semibold ml-2 gm-legacy-automation__rule-name">{{ option.name }}</span>
                    <span
                      class="cursor-pointer ml-2 gm-legacy-automation__rule-remove"
                      @click="deletepre(option)"
                    >
                      <i class="fas fa-times"></i>
                    </span>
                  </div>

                  <div
                    v-if="
                      localModel.prefields[localModel.prefields.length - 1] !=
                        option
                    "
                    class="rounded-full h-12 w-12 flex items-center justify-center border border-primary mr-5 ml-5 gm-legacy-automation__and"
                  >
                    {{ $t('frontend_groovemail_analytics_list_and') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="font-semibold text-grey-800 text-lg text-center mt-6 mb-2 gm-legacy-automation__heading">
          {{ $t('frontend_groovemail_analytics_list_then') }}
        </div>
        <div class="flex flex-col w-full mb-6 gm-legacy-automation__rule-section">
          <div class="flex gm-legacy-automation__choice-row">
            <div class="flex flex-1 gm-legacy-automation__choice-controls">
              <div class="w-5/12 pr-2">
                <select
                  v-model="localModel.post_mainselect"
                  class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                  @change="changepostselect($event)"
                >
                  <option value="">
                    {{ $t('frontend_automations_select_action') }}
                  </option>
                  <option
                    v-for="action in this.actions"
                    :key="action.value"
                    :value="action.value"
                    :data-type="action.dataType"
                    :data-operation="action.operation"
                    :disabled="action.disabled"
                  >
                    {{ action.value }}
                  </option>
                </select>
              </div>
              <div
                v-if="
                  localModel.post_mainselect ==
                    $t('frontend_automations_actions_subscribe_to_list') ||
                    localModel.post_mainselect ==
                      $t('frontend_automations_actions_unsubscribe_to_list')
                "
                class="w-7/12 pr-2"
              >
                <select
                  v-model="localModel.postdata"
                  class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                  @change="assignpostname($event)"
                >
                  <option value="">
                    {{ $t('frontend_automations_select_list') }}
                  </option>
                  <option
                    v-for="list in this.post_lists"
                    :key="list.id"
                    :value="list.id"
                    :data-name="list.name"
                  >
                    {{ list.name }}
                  </option>
                </select>
              </div>
              <div
                v-else-if="
                  localModel.post_mainselect ==
                    $t('frontend_automations_actions_subscribe_to_sequence') ||
                    localModel.post_mainselect ==
                      $t('frontend_automations_actions_unsubscribe_from_sequence')
                "
                class="w-7/12 pr-2"
              >
                <select
                  v-model="localModel.postdata"
                  class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                  @change="assignpostname($event)"
                >
                  <option value="">
                    {{ $t('frontend_automations_select_sequence') }}
                  </option>
                  <option
                    v-for="sequence in this.post_sequences"
                    :key="sequence.id"
                    :value="sequence.id"
                    :data-name="sequence.name"
                  >
                    {{ sequence.name }}
                  </option>
                </select>
              </div>
              <div
                v-else-if="
                  localModel.post_mainselect ==
                    $t('frontend_automations_actions_add_tag') ||
                    localModel.post_mainselect ==
                      $t('frontend_automations_actions_remove_tag')
                "
                class="w-7/12 pr-2"
              >
                <div class="flex">
                  <div class="w-1/2 pr-2">
                    <select
                      class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                      @change="postcategory($event)"
                    >
                      <option value="">
                        {{ $t('frontend_automations_select_category') }}
                      </option>
                      <option
                        v-for="category in this.post_categories"
                        :key="category.id"
                        :value="category.id"
                      >
                        {{ category.name }}
                      </option>
                    </select>
                  </div>
                  <div class="w-1/2">
                    <select
                      v-model="localModel.postdata"
                      class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                      @change="assignpostname($event)"
                    >
                      <option value="">
                        {{ $t('frontend_automations_select_tag') }}
                      </option>
                      <option
                        v-for="tag in this.post_tags"
                        :key="tag.id"
                        :value="tag.id"
                        :data-name="tag.name"
                      >
                        {{ tag.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div
                v-else-if="
                  localModel.post_mainselect ==
                    $t('frontend_automations_actions_refund_a_purchase') ||
                    localModel.post_mainselect ==
                      $t('frontend_automations_trigger_lead_cancel_a_subscription')
                "
                class="w-7/12 flex pr-2"
              >
                <select
                  v-model="localModel.postfunnelid"
                  class="text-sm rounded w-4/12 mr-2 bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                  @change="postfunnelid($event)"
                >
                  <option value="">
                    {{ $t('frontend_automations_select_funnel') }}
                  </option>
                  <option
                    v-for="funnel in this.post_funnels"
                    :key="funnel.id"
                    :value="funnel.id"
                    :data-name="funnel.name"
                  >
                    {{ funnel.name }}
                  </option>
                </select>

                <select
                  v-model="localModel.postproductid"
                  class="text-sm rounded w-4/12 mr-2 bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                  @change="postproductid($event)"
                >
                  <option value="">
                    {{ $t('frontend_automations_select_product') }}
                  </option>
                  <option
                    v-for="product in this.post_products"
                    :key="product.id"
                    :value="product.id"
                    :data-name="product.name"
                  >
                    {{ product.name }}
                  </option>
                </select>

                <select
                  v-model="localModel.postpricepointid"
                  class="text-sm rounded w-4/12 bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                  @change="postpricepointid($event)"
                >
                  <option value="">
                    {{ $t('frontend_automations_select_price_point') }}
                  </option>
                  <option
                    v-for="pricePoint in this.post_price_points"
                    :key="pricePoint.id"
                    :value="pricePoint.id"
                    :data-name="pricePoint.name"
                  >
                    {{ pricePoint.name }}
                  </option>
                </select>
              </div>
              <div
                v-else-if="
                  localModel.post_mainselect ==
                    $t('frontend_automations_actions_add_as_an_affiliate')
                "
                class="w-7/12 pr-2 flex flex-col"
              >
                <div class="w-11/12 flex flex-row">
                  <select
                    v-model="localModel.affiliateActionType"
                    class="text-sm rounded float-left w-1/2 ml-2 bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                    @change="updatedAffiliateActionType($event)"
                  >
                    <option value="0">
                      {{ $t('frontend_automations_default_commision_tier') }}
                    </option>
                    <option value="1">
                      {{ $t('frontend_automations_custom_commision_tier') }}
                    </option>
                  </select>
                  <select
                    v-model="localModel.postfunnelid"
                    class="text-sm rounded float-left w-1/2 ml-2 bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                    @change="postfunnelid($event)"
                  >
                    <option value="">
                      {{ $t('frontend_automations_select_funnel') }}
                    </option>
                    <option
                      v-for="funnel in this.post_funnels"
                      :key="funnel.id"
                      :value="funnel.id"
                      :data-name="funnel.name"
                    >
                      {{ funnel.name }}
                    </option>
                  </select>
                </div>

                <div class="w-11/12 flex flex-row">
                  <select
                    v-if="localModel.affiliateActionType == 1"
                    v-model="localModel.postproductid"
                    class="text-sm rounded float-left w-1/3 mt-2 ml-2 bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                    @change="postproductid($event)"
                  >
                    <option value="">
                      {{ $t('frontend_automations_select_product') }}
                    </option>
                    <option
                      v-for="product in this.post_products"
                      :key="product.id"
                      :value="product.id"
                      :data-name="product.name"
                    >
                      {{ product.name }}
                    </option>
                  </select>

                  <select
                    v-if="localModel.affiliateActionType == 1"
                    v-model="localModel.postpricepointid"
                    class="text-sm rounded float-left w-1/3 mt-2 ml-2 bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                    @change="postpricepointid($event)"
                  >
                    <option value="">
                      {{ $t('frontend_automations_select_price_point') }}
                    </option>
                    <option
                      v-for="pricePoint in this.post_price_points"
                      :key="pricePoint.id"
                      :value="pricePoint.id"
                      :data-name="pricePoint.name"
                    >
                      {{ pricePoint.name }}
                    </option>
                  </select>

                  <select
                    v-if="localModel.affiliateActionType == 1"
                    v-model="localModel.commissiontierid"
                    class="text-sm rounded float-left w-1/3 mt-2 ml-2 bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                    @change="postcommissiontierid($event)"
                  >
                    <option value="">
                      {{ $t('frontend_automations_select_commision_tier') }}
                    </option>
                    <option
                      v-for="commissionTier in this.post_commmision_tiers"
                      :key="commissionTier.id"
                      :value="commissionTier.id"
                      :data-name="commissionTier.name"
                    >
                      {{ commissionTier.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div
                v-else-if="
                  localModel.post_mainselect ==
                    $t('frontend_automations_actions_add_a_membership')
                "
                class="w-7/12 pr-2 flex gap-2"
              >
                <select
                  v-model="localModel.postmembershipid"
                  class="text-sm rounded float-left w-1/2 bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                  @change="postmembershipid($event)"
                >
                  <option value="">
                    {{ $t('frontend_automations_select_membership') }}
                  </option>
                  <option
                    v-for="membership in this.post_memberships"
                    :key="membership.id"
                    :value="membership.id"
                    :data-name="membership.name"
                  >
                    {{ membership.name }}
                  </option>
                </select>

                <select
                  v-model="localModel.postaccesslevelid"
                  class="text-sm rounded float-left w-1/2 bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                  @change="postaccesslevelid($event)"
                >
                  <option value="">
                    {{ $t('frontend_automations_select_access_level') }}
                  </option>
                  <option
                    v-for="accessLevel in this.post_access_levels"
                    :key="accessLevel.secret_key"
                    :value="accessLevel.secret_key"
                    :data-name="accessLevel.name"
                  >
                    {{ accessLevel.name }}
                  </option>
                </select>
              </div>
              <!-- <div
                v-else-if="
                  localModel.post_mainselect ==
                    $t('frontend_automations_actions_add_to_integration')
                "
                class="w-7/12 pr-2"
              >
                <div class="flex items-start w-full">
                  <gd-dropdown
                    class="integration-select"
                    :class="{
                      'integration-select-small': integrationType,
                      'integration-select-large': !integrationType,
                    }"
                    :v-bind="integrationType"
                    :value="integrationType"
                    :placeholder="$t('frontend_select')"
                    :options="availableIntegrations()"
                    variant="base"
                    size="full"
                    @change="setValue($event)"
                    @keyup="setValue($event)"
                  />
                  <div
                    v-if="integrationType && integrationType != ''"
                    class="w-full -mx-4"
                  >
                    <config-menu
                      :key="configMenuKey"
                      :initial-values="componentConfigValues"
                      :plugin-id="pluginId"
                      :resources-path="resourcesPath()"
                      :server-path="serverPath()"
                      :plugin="integrationType"
                      :app-data="pluginSiteData()"
                      layout="horizontal"
                      :is-dark="false"
                      :show-button-borders="false"
                      :show-notifications-on-save="false"
                      :btn-label="$t('frontend_add')"
                      :opened-from="appName"
                      @update="addAffiliateRegistrationIntegration"
                      @menu-updated="configMenuItemsUpdated"
                    >
                    </config-menu>
                  </div>
                </div>
              </div> -->
              <div v-else class="w-7/12 pr-2">
                <select
                  class="h-10 text-sm rounded w-full bg-white border border-grey-300 text-grey-700 py-2 px-2 pr-6"
                >
                  <option value="">{{ $t('frontend_select') }}</option>
                </select>
              </div>
            </div>
            <div
              class="gm-legacy-automation__choice-add"
              v-if="
                localModel.post_mainselect !==
                  $t('frontend_automations_actions_add_to_integration')
              "
            >
              <gd-button
                variant="primary"
                size="icon"
                :disabled="!localModel.postdata"
                class="h-10 w-10 gm-legacy-automation__add-rule"
                @click="localModel.postdata != '' ? addpostfield() : null"
              >
                <PlusIcon class="h-7 w-7" />
              </gd-button>
            </div>
          </div>
          <div class="flex pt-4 gm-legacy-automation__rule-list">
            <div class="w-full">
              <div class="flex flex-wrap items-center gm-legacy-automation__rule-items">
                <div
                  v-for="option in this.localModel.postfields"
                  :key="option.id"
                  class="flex items-center gm-legacy-automation__rule-item"
                >
                  <div class="flex flex-row rounded px-2 py-1 font-semibold text-primary-invert text-xs bg-primary gm-legacy-automation__rule-chip">
                    {{ option.action }}
                    <span class="font-semibold ml-2 gm-legacy-automation__rule-name">{{ option.name }}</span>
                    <span
                      class="cursor-pointer ml-2 gm-legacy-automation__rule-remove"
                      @click="deletepost(option)"
                    >
                      <i class="fas fa-times"></i>
                    </span>
                  </div>

                  <div
                    v-if="
                      localModel.postfields[localModel.postfields.length - 1] !=
                        option
                    "
                    class="rounded-full h-10 w-10 flex items-center justify-center border text-primary border-primary mr-5 ml-5 gm-legacy-automation__and"
                  >
                    {{ $t('frontend_groovemail_analytics_list_and') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-end gm-legacy-automation__footer">
        <gd-button
          class="gm-legacy-automation__cancel"
          size="auto"
          @click="closeAutomationCreateModal"
          >{{ $t('frontend_cancel') }}</gd-button
        >
        <gd-button
          class="ml-2 gm-legacy-automation__save"
          size="auto"
          variant="primary"
          :disabled="
            !(
              localModel.prefields &&
              localModel.prefields.length > 0 &&
              localModel.postfields &&
              localModel.postfields.length > 0
            )
          "
          :class="{ 'disabled-btn bg-primary text-primary-invert border-primary': !(
              localModel.prefields &&
              localModel.prefields.length > 0 &&
              localModel.postfields &&
              localModel.postfields.length > 0
            )
          }"
          @click="
            localModel.prefields &&
            localModel.prefields.length > 0 &&
            localModel.postfields &&
            localModel.postfields.length > 0
              ? type === 'add'
                ? saveAutomation()
                : updateAutomation()
              : null
          "
          >{{ $t('frontend_save') }}</gd-button
        >
      </div>
    </div>
  </VuePerfectScrollbar>
</template>

<script>
import axios from 'axios';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import auth from '@groovepages/gd-lib/auth';
import ConfigMenu from "@groovepages/gd-ui-kit/components/PluginMenu";
import Mailform from '@/models/Mailform';
import Category from '@/models/Category';
import Mailsequence from '@/models/Mailsequence';
import { showRequestErrorAlert } from '@/components/showDialog.js';

// import icons
import PlusIcon from '@/assets/images/icons/new/plus-small_new.svg';


export default {
  middleware: 'auth',
  props: ['triggers', 'model', 'type', 'actions'],
  data() {
    return {
      appName: '',
      pluginMenuItems: [],
      configMenuKey: 1,
      integrationType: '',
      componentConfigValues: [],
      pluginId: '',
      localModel: this.model,
      isLoading: false,
      vcase: 0,
      tabvalue: '',
      pre_funnels: [],
      pre_products: [],
      pre_price_points: [],
      post_funnels: [],
      post_products: [],
      post_price_points: [],
      pre_lists: [],
      pre_categories: [],
      pre_tags: [],
      pre_forms: [],
      pre_sequences: [],
      post_lists: [],
      post_categories: [],
      post_tags: [],
      post_sequences: [],
      post_memberships: [],
      post_access_levels: [],
      pre_addbtn: false,
      post_addbtn: false,
      post_commmision_tiers: [],
      broadcasts: [],
      broadcastLinks: [],
      sequences: [],
      emailNodes: [],
      sequenceEmailLinks: [],
    };
  },

  computed: {
    // Used to return brandData value from store.
    supBrandName() {
      return this.$store.getters.supBrand.title;
    },
  },

  mounted() {
    this.appName = this.supBrandName;
  },

  watch: {
    'localModel.prefields.length': function watchPrefields() {
      if (this.localModel.prefields.length) {
        this.$emit('preFieldsUpdated', 1);
      } else {
        this.$emit('preFieldsUpdated', 0);
      }
    },
    localModel() {
      this.$emit('updateModel', this.localModel);
    },
  },
  async created() {
    this.showLoader();
    try {
      this.initalizePreFieldsOptions();
      const mailLists = await axios.get(`/maillistonly`);
      this.pre_lists = mailLists?.data?.data;
      this.post_lists = mailLists?.data?.data;
      this.pre_sequences = await Mailsequence.$get();
      this.post_sequences = await Mailsequence.$get();
      this.pre_forms = await Mailform.$get();
      this.pre_categories = await Category.$get();
      this.post_categories = await Category.$get();

      this.hideLoader();
    } catch (error) {
      this.hideLoader();
      
      // show error alert
      showRequestErrorAlert(error?.response?.data?.message);
    }
  },
  validations: {
    localModel: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
    },
  },
  methods: {
    initalizePreFieldsOptions() {
      if (
        this.localModel &&
        this.localModel.postfields &&
        this.localModel.postfields.length &&
        this.localModel.prefields &&
        this.localModel.prefields.length
      ) {
        this.$emit('preFieldsUpdated', 1);
      } else {
        this.$emit('preFieldsUpdated', 0);
      }
    },
    
    configMenuItemsUpdated(data) {
      this.pluginMenuItems = data.menuItems;
      const integration = this.pluginMenuItems.find((ele) => {
        return ele.key === 'integration';
      });
      this.localModel.integrationId = integration.default;
    },

    addAffiliateRegistrationIntegration(data) {
      const integrationConfig = data.config;
      const self = this;

      const integrationInfo = [];

      for (const index in integrationConfig) {
        const value = integrationConfig[index];

        if (value) {
          self.pluginMenuItems.forEach((menuValue, menuIndex) => {
            if (menuValue.key === index) {
              const {options} = menuValue;

              const objChecker = options.some((val) => {
                return typeof val === 'object';
              });

              let correspondingOption = value;
              if (objChecker) {
                correspondingOption = options.find((o) => o.value === value);
              }

              const singleIntegrationField = {};
              singleIntegrationField.index = index;
              singleIntegrationField.value = value;
              singleIntegrationField.label = menuValue.label;

              if (objChecker) {
                singleIntegrationField.name = correspondingOption.text;
              } else {
                singleIntegrationField.name = value;
              }

              integrationInfo.push(singleIntegrationField);
            }
          });
        }
      }

      const completeIntegrationInfo = {};
      completeIntegrationInfo.platform = this.integrationType.split('-')[0];
      completeIntegrationInfo.config = integrationInfo;
      this.localModel.integration_config = completeIntegrationInfo;
      this.localModel.postdata = `${this.localModel.post_mainselect} ${this.localModel.integration_config.platform}`;

      this.localModel.postfields.push({
        id: this.localModel.integrationId,
        name: this.localModel.integration_config.platform,
        type: this.localModel.post_main_type,
        action: this.localModel.post_mainselect,
        integration_config: this.localModel.integration_config,
        operation: this.localModel.postoperation,
      });

      this.integrationType = '';
      this.localModel.postdata = '';
      this.localModel.postdataname = '';
      this.localModel.post_main_type = '';
      this.localModel.post_mainselect = '';
      this.localModel.postoperation = '';
      this.localModel.integrationId = '';
      this.localModel.integration_config = '';
    },

    pluginSiteData() {
      return this.$store.getters.pluginSiteSettings;
    },

    resourcesPath() {
      return `${window.gdEnv.VUE_APP_STORAGE_URL}/plugins/`;
    },

    serverPath() {
      return `${window.gdEnv.VUE_APP_API_URL}/groovedigital/plugins/call/`;
    },

    availableIntegrations() {
      const user = auth.authenticatedUser();
      if (user.metadata && user.metadata.integrations) {
        const integrations = [];
        user.metadata.integrations.map((value) => {
          const integrationId = value.id;
          const integrationType = value.type.split('-')[0];
          const integrationPlugin = `${integrationType  }-component`;
          if (
            value.type !== 'zapier-integration' &&
            integrations.findIndex((x) => x.value === integrationPlugin) === -1
          ) {
            integrations.push({
              text:
                integrationType.charAt(0).toUpperCase() +
                integrationType.slice(1),
              value: integrationPlugin,
              id: integrationId,
            });
          }
        });

        return integrations;
      }
        return [];

    },

    setValue(value) {
      this.integrationType = value;
      this.pluginId = '';
      this.componentConfigValues = [];
      this.configMenuKey = this.configMenuKey + 1;

      this.localModel.integrationId = '';
      this.localModel.integration_config = '';
    },

    saveAutomation() {
      this.$v.localModel.name.$touch();

      // save automation
      this.$emit('saveAutomation', 1);
    },

    updateAutomation() {
      this.$v.localModel.name.$touch();

      // update automation
      this.$emit('updateAutomation', 1);
    },

    postfunnelid(event) {
      // Convert the event value to a number
      const selectedId = typeof event.target.value === 'string' ?  Number(event.target.value) : event.target.value;

      if (
        this.localModel.post_main_type === 'groovesell-refund-order' ||
        this.localModel.post_main_type === 'groovesell-cancel-subscription'
      ) {
        this.localModel.postproductid = '';
        this.localModel.postpricepointid = '';
        this.post_addbtn = false;
        this.post_price_points = [];        
        this.localModel.postdata = '';

        // Find the current funnel based on the selected id
        const currentFunnel = this.post_funnels.find(
          (element) => element.id === selectedId
        );

        if (currentFunnel) {
          this.post_products = currentFunnel.products;
        } else {
          this.post_products = [];
        }
      } else if (this.localModel.post_main_type === 'groovesell-add-affiliate') {
        this.post_addbtn = true;
        this.localModel.postdata = '';
        this.post_price_points = [];

        const selectedPostFunnel = this.post_funnels.find((ele) => {
          return ele.id === this.localModel.postfunnelid;
        });
        this.post_products = this.post_price_points = this.post_commmision_tiers = [];
        if (selectedPostFunnel) {
          if (this.localModel.affiliateActionType === '0') {
            this.localModel.postdata = {
              funnel_id: this.localModel.postfunnelid,
              funnel: selectedPostFunnel.name,
            };
            this.localModel.postdataname = ` ${selectedPostFunnel.name}`;
            this.post_addbtn = true;
          } else if (this.localModel.affiliateActionType === '1') {
            this.localModel.postdata = '';
            this.localModel.postdataname = '';
            this.post_addbtn = false;
            this.localModel.postproductid = '';
            this.localModel.postpricepointid = '';
            this.localModel.commissiontierid = '';
            this.post_addbtn = false;
            this.localModel.postdata = '';
            const currentFunnel = this.post_funnels.find(
              (element) => element.id === selectedId
            );
            if (currentFunnel) {
              this.post_products = currentFunnel.products;
            } else {
              this.post_products = [];
            }
          }
        } else {
          this.localModel.postdata = '';
          this.localModel.postdataname = '';
          this.post_addbtn = false;
          this.localModel.postproductid = '';
          this.localModel.postpricepointid = '';
          this.localModel.commissiontierid = '';
          this.post_price_points = [];
        }
      }
    },

    postproductid(event) {
      this.post_price_points = this.post_commmision_tiers = [];
      this.localModel.postpricepointid = '';
      this.localModel.commissiontierid = '';
      this.post_addbtn = false;
      this.localModel.postdata = '';
      
      // Convert the event value to a number
      const selectedId = typeof event.target.value === 'string' ?  Number(event.target.value) : event.target.value;

      // Find the current product based on the selected id
      const currentProduct = this.post_products.find(
        (element) => element.id === selectedId
      );
      if (currentProduct) {
        this.post_price_points = currentProduct.price_points;
      }
    },

    postpricepointid(event) {
      this.post_commmision_tiers = [];

      // Convert the event value to a number
      const selectedId = typeof event.target.value === 'string' ?  Number(event.target.value) : event.target.value;

      if (this.localModel.post_main_type === 'groovesell-add-affiliate') {
        if (this.localModel.affiliateActionType === '1') {
          this.localModel.commissiontierid = '';
          this.post_addbtn = false;
          this.localModel.postdata = '';
          const currentPricePoint = this.post_price_points.find(
            (element) => element.id === selectedId
          );
          if (currentPricePoint) {
            currentPricePoint.commission_details.forEach((ele) => {
              if (ele.type === 2) {
                this.post_commmision_tiers.push(ele);
              }
            });
          } else {
            this.post_commmision_tiers = [];
          }
        }
      } else {
        const selectedPostFunnel = this.post_funnels.find((ele) => {
          return ele.id === this.localModel.postfunnelid;
        });
        const selectedPostProduct = this.post_products.find((ele) => {
          return ele.id === this.localModel.postproductid;
        });
        const selectedPostPricePoint = this.post_price_points.find((ele) => {
          return ele.id === this.localModel.postpricepointid;
        });
        if (selectedPostPricePoint) {
          this.localModel.postdata = {
            funnel_id: this.localModel.postfunnelid,
            funnel: selectedPostFunnel.name,
            product_id: this.localModel.postproductid,
            product: selectedPostProduct.name,
            pricepoint_id: this.localModel.postpricepointid,
            pricePoint: selectedPostPricePoint.name,
          };
          this.localModel.postdataname = ` ${selectedPostFunnel.name}, ${selectedPostProduct.name}, ${selectedPostPricePoint.name}`;
          this.post_addbtn = true;
        } else {
          this.post_addbtn = false;
          this.localModel.postdataname = '';
        }
      }
    },

    postcommissiontierid() {
      const selectedPostFunnel = this.post_funnels.find((ele) => {
        return ele.id === this.localModel.postfunnelid;
      });
      const selectedPostProduct = this.post_products.find((ele) => {
        return ele.id === this.localModel.postproductid;
      });
      const selectedPostPricePoint = this.post_price_points.find((ele) => {
        return ele.id === this.localModel.postpricepointid;
      });
      const selectedCommissionTier = this.post_commmision_tiers.find((ele) => {
        return ele.id === this.localModel.commissiontierid;
      });
      if (selectedCommissionTier) {
        this.localModel.postdata = {
          funnel_id: this.localModel.postfunnelid,
          funnel: selectedPostFunnel.name,
          product_id: this.localModel.postproductid,
          product: selectedPostProduct.name,
          pricepoint_id: this.localModel.postpricepointid,
          pricePoint: selectedPostPricePoint.name,
          commission_id: this.localModel.commissiontierid,
          commission: selectedCommissionTier.name,
        };
        this.localModel.postdataname = ` ${selectedPostFunnel.name}, ${selectedPostProduct.name}, ${selectedPostPricePoint.name}, ${selectedCommissionTier.name}`;
        this.post_addbtn = true;
      } else {
        this.post_addbtn = false;
        this.localModel.postdataname = '';
      }
    },

    postmembershipid() {
      this.localModel.postaccesslevelid = '';
      this.post_addbtn = false;
      this.localModel.postdata = '';
      const selectedPostMembership = this.post_memberships.find((ele) => {
        return ele.id === this.localModel.postmembershipid;
      });
      if (selectedPostMembership) {
        this.post_access_levels = selectedPostMembership.access_level;
      } else {
        this.post_access_levels = [];
      }
    },

    postaccesslevelid() {
      const selectedPostMembership = this.post_memberships.find((ele) => {
        return ele.id === this.localModel.postmembershipid;
      });
      const selectedAccessLevel = this.post_access_levels.find((ele) => {
        return ele.secret_key === this.localModel.postaccesslevelid;
      });

      if (selectedAccessLevel) {
        this.localModel.postdata = {
          membership_id: this.localModel.postmembershipid,
          membership: selectedPostMembership.name,
          secret_key: this.localModel.postaccesslevelid,
          access_level: selectedAccessLevel.name,
        };
        this.localModel.postdataname = ` ${selectedPostMembership.name}, ${selectedAccessLevel.name}`;
        this.post_addbtn = true;
      } else {
        this.localModel.postdataname = '';
        this.post_addbtn = false;
      }
    },

    assignpricepointid() {
      const selectedPreFunnel = this.pre_funnels.find((ele) => {
        return ele.id === this.localModel.funnelid;
      });
      const selectedPreProduct = this.pre_products.find((ele) => {
        return ele.id === this.localModel.productid;
      });
      const selectedPrePricePoint = this.pre_price_points.find((ele) => {
        return ele.id === this.localModel.pricepointid;
      });
      if (selectedPrePricePoint) {
        this.localModel.predata = {
          funnel_id: this.localModel.funnelid,
          funnel: selectedPreFunnel.name,
          product_id: this.localModel.productid,
          product: selectedPreProduct.name,
          pricepoint_id: this.localModel.pricepointid,
          pricePoint: selectedPrePricePoint.name,
        };
        this.localModel.predataname = ` ${selectedPreFunnel.name}, ${selectedPreProduct.name}, ${selectedPrePricePoint.name}`;
        this.pre_addbtn = true;
      } else {
        this.localModel.predata = {
          funnel_id: this.localModel.funnelid,
          funnel: selectedPreFunnel.name,
          product_id: this.localModel.productid,
          product: selectedPreProduct.name,
          pricepoint_id: 0,
          pricePoint: this.$t('frontend_automations_select_any_price_point'),
        };
        this.localModel.predataname = ` ${selectedPreFunnel.name}, ${
          selectedPreProduct.name
        }, ${this.$t('frontend_automations_select_any_price_point')}`;
        this.pre_addbtn = true;
      }
    },


    /* Purchase a product && Refund a purchase && Cancel a subscription && abndon a cart */
    assignfunnelid(event) {
      this.localModel.productid = '';
      this.localModel.pricepointid = '';
      this.pre_addbtn = false;
      this.localModel.predata = '';
      
      // Convert the event value to a number
      const selectedId = typeof event.target.value === 'string' ?  Number(event.target.value) : event.target.value;

      // find the current funnel from the list of funnels based on the selected funnel id
      const currentFunnel = this.pre_funnels.find((element) => element.id === selectedId);
      
      if (currentFunnel) {
        this.localModel.predata = {
          funnel_id: this.localModel.funnelid,
          funnel: currentFunnel.name,
          product_id: 0,
          product: this.$t('frontend_automations_select_any_product'),
          pricepoint_id: 0,
          pricePoint: this.$t('frontend_automations_select_any_price_point'),
        };
        this.localModel.predataname = ` ${currentFunnel.name}, ${this.$t(
          'frontend_automations_select_any_product'
        )}, ${this.$t('frontend_automations_select_any_price_point')}`;
        this.pre_addbtn = true;
        this.pre_products = currentFunnel.products;
        this.pre_price_points = [];
      } else {
        this.pre_products = [];
        this.pre_addbtn = true;
        this.pre_price_points = [];
      }
    },

    // assign product data to the local model based on the selected funnel id
    assignproductid(event) {
      this.localModel.predata = '';
      this.localModel.pricepointid = '';
      this.pre_addbtn = false;

      // Convert the event value to a number
      const selectedId = typeof event.target.value === 'string' ?  Number(event.target.value) : event.target.value;

      // find the current product from the list of products based on the selected product id
      const currentProduct = this.pre_products.find(
        (element) => element.id === selectedId
      );

      // find the current funnel from the list of funnels based on the selected funnel id
      const currentFunnel = this.pre_funnels.find(
        (element) => element.id === this.localModel.funnelid
      );

      if (currentProduct) {
        this.localModel.predata = {
          funnel_id: this.localModel.funnelid,
          funnel: currentFunnel.name,
          product_id: this.localModel.productid,
          product: currentProduct.name,
          pricepoint_id: 0,
          pricePoint: this.$t('frontend_automations_select_any_price_point'),
        };
        this.localModel.predataname = ` ${currentFunnel.name}, ${
          currentProduct.name
        }, ${this.$t('frontend_automations_select_any_price_point')}`;
        this.pre_addbtn = true;
        this.pre_price_points = currentProduct.price_points;
      } else {
        this.localModel.predata = {
          funnel_id: this.localModel.funnelid,
          funnel: currentFunnel.name,
          product_id: 0,
          product: this.$t('frontend_automations_select_any_product'),
          pricepoint_id: 0,
          pricePoint: this.$t('frontend_automations_select_any_price_point'),
        };
        this.localModel.predataname = ` ${currentFunnel.name}, ${this.$t(
          'frontend_automations_select_any_product'
        )}, ${this.$t('frontend_automations_select_any_price_point')}`;
        this.pre_addbtn = false;
        this.pre_price_points = [];
      }
    },


    /* open link in boradcast email && clicked link in boradcast email */
    async assignBroadcastId(event) {
      this.localModel.predata = '';
      this.localModel.broadcast_link_id = '';
      this.pre_addbtn = false;

      // find the current broadcast from the list of broadcasts based on the selected broadcast id
      const currentBroadcast = this.broadcasts.find(
        (element) => element.id === event.target.value
      );

      if (currentBroadcast) {
        if (this.localModel.pre_mainselect === this.$t('frontend_groovemail_leads_filter_opened_a_broadcast_option')) {
          this.localModel.predata = {
            broadcast_id: this.localModel.broadcast_id,
            broadcast: currentBroadcast.name,
          };
          this.localModel.predataname = `${currentBroadcast.name}`;
          this.pre_addbtn = true;
        } else if (this.localModel.pre_mainselect === this.$t('frontend_groovemail_leads_filter_clicked_a_link_option')) {
          this.localModel.predata = {
            broadcast_id: this.localModel.broadcast_id,
            broadcast: currentBroadcast.name,
            broadcast_link_id: 0,
            broadcast_link: this.$t('frontend_groovemail_automations_trigger_link_any_link_label'),
          };
          this.localModel.predataname = `${currentBroadcast.name}, ${this.$t('frontend_groovemail_automations_trigger_link_any_link_label')}`;
          this.pre_addbtn = true;
          await this.fetchBroadcastsLinks(currentBroadcast);
        }
      } else {
        this.broadcastLinks = [];
      }
    },

    async fetchBroadcastsLinks(broadcast) {
      this.showLoader();
      try {
        const linksData = await axios.post('/campaign-tracking-link', {campaign_id: broadcast.id,});

        // check if the links data is available
        if (linksData?.data) {
          this.broadcastLinks = linksData.data;
        }

        this.hideLoader();
      } catch(error) {
        this.broadcastLinks = [];
        this.hideLoader();

        // show error alert
        showRequestErrorAlert(error?.response?.data?.message);
      }
    },

    assignBroadcastLinkId(event) {
      this.localModel.predata = '';
      this.pre_addbtn = false;

      // find the current link from the list of links based on the selected link id
      const currentLink = this.broadcastLinks.find(
        (element) => element.id === event.target.value
      );
      const currentBroadcast = this.broadcasts.find(
        (element) => element.id === this.localModel.broadcast_id
      );
      if (currentLink) {
        this.localModel.predata = {
          broadcast_id: this.localModel.broadcast_id,
          broadcast: currentBroadcast.name,
          broadcast_link_id: this.localModel.broadcast_link_id,
          broadcast_link: currentLink.redirect_url,
        };
        this.localModel.predataname = `${currentBroadcast.name}, ${currentLink.redirect_url}`;
        this.pre_addbtn = true;
      }
    },

    /* open sequence email && clicked link in sequence email */
    async assignSequenceId(event) {
      this.localModel.predata = '';
      this.localModel.email_node_id = '';
      this.localModel.sequence_email_node_link_id = '';
      this.pre_addbtn = false;
      
      // find the current sequence from the list of sequences based on the selected sequence id
      const currentSequence = this.sequences.find(
        (element) => element.id === event.target.value
      );

      if (currentSequence) {
        if (this.localModel.pre_mainselect === this.$t('frontend_groovemail_automations_trigger_opened_email_from_sequence')) {
          this.localModel.predata = {
            sequence: currentSequence.name,
            sequence_id: this.localModel.sequence_id,
            email_node: this.$t('frontend_groovemail_automations_trigger_link_any_email_node_label'),
            email_node_id: 0,
          };
          this.localModel.predataname = `${currentSequence.name}, ${this.$t('frontend_groovemail_automations_trigger_link_any_email_node_label')}`;
          this.pre_addbtn = true;
        } else if (this.localModel.pre_mainselect === this.$t('frontend_groovemail_automations_trigger_clicked_link_in_email_from_sequence')) {
          this.localModel.predata = {
            sequence: currentSequence.name,
            sequence_id: this.localModel.sequence_id,
            email_node: this.$t('frontend_groovemail_automations_trigger_link_any_email_node_label'),
            email_node_id: 0,
            email_link: this.$t('frontend_groovemail_automations_trigger_link_any_link_label'),
            email_link_id: 0,
          };
          this.localModel.predataname = `${currentSequence.name},
            ${this.$t('frontend_groovemail_automations_trigger_link_any_email_node_label')}, 
            ${this.$t('frontend_groovemail_automations_trigger_link_any_link_label')}`;
          this.pre_addbtn = true;
          this.sequenceEmailLinks = [];
        }
        await this.fetchEmailNodes(currentSequence);
      } else {
        this.emailNodes = [];
        this.sequenceEmailLinks = [];
      }
    },
    
    // for fetching email nodes based on the selected sequence
    async fetchEmailNodes(currentSequence) {
      this.showLoader();
      try {
        const emailNodesData = await axios.get(`/sequence/${currentSequence.id}`);
        this.emailNodes = emailNodesData?.data?.data ? emailNodesData.data.data : [];
        this.hideLoader();
      } catch(error) {
        this.emailNodes = [];
        this.hideLoader();

        // show error alert
        showRequestErrorAlert(error?.response?.data?.message);
      }
    },

    async assignEmailNodeId(event) {
      this.localModel.predata = '';
      this.localModel.sequence_email_node_link_id = '';
      this.pre_addbtn = false;

      // find the current node from the list of nodes based on the selected node id
      const currentNode = this.emailNodes.find(
        (element) => element.id === event.target.value
      );

      const currentSequence = this.sequences.find(
        (element) => element.id === this.localModel.sequence_id
      );

      if (currentNode) {
        if (this.localModel.pre_mainselect === this.$t('frontend_groovemail_automations_trigger_opened_email_from_sequence')) {
          this.localModel.predata = {
            sequence: currentSequence.name,
            sequence_id: this.localModel.sequence_id,
            email_node: currentNode.name,
            email_node_id: this.localModel.email_node_id,
          };
          this.localModel.predataname = `${currentSequence.name}, ${currentNode.name}`;
          this.pre_addbtn = true;
        } else if (this.localModel.pre_mainselect === this.$t('frontend_groovemail_automations_trigger_clicked_link_in_email_from_sequence')) {
          this.localModel.predata = {
            sequence: currentSequence.name,
            sequence_id: this.localModel.sequence_id,
            email_node: currentNode.name,
            email_node_id: this.localModel.email_node_id,
            email_link: this.$t('frontend_groovemail_automations_trigger_link_any_link_label'),
            email_link_id: 0,
          };
          this.localModel.predataname = `${currentSequence.name}, ${currentNode.name}, 
            ${this.$t('frontend_groovemail_automations_trigger_link_any_link_label')}`;
          this.pre_addbtn = true;
        }
        await this.fetchSequenceEmailLinks(currentNode);
      } else {
        // this.emailNodes = [];
        this.sequenceEmailLinks = [];
      }
    },

    // for fetching email links based on the selected node
    async fetchSequenceEmailLinks(currentNode) {
      this.showLoader();
      try {
        const sequenceEmailLinkData = await axios.get(`/sequence/link/${currentNode.id}`);
        this.sequenceEmailLinks = sequenceEmailLinkData?.data?.data ? sequenceEmailLinkData.data.data : this.sequenceEmailLinks;
        this.hideLoader();
      } catch(error) {
        this.sequenceEmailLinks = [];
        this.hideLoader();

        // show error alert
        showRequestErrorAlert(error?.response?.data?.message);
      }
    },

    async assignSequenceEmailLinkId(event) {
      this.localModel.predata = '';
      this.pre_addbtn = false;

      // find the current link from the list of links based on the selected link id
      const currentLink = this.sequenceEmailLinks.find(
        (element) => element.id === event.target.value
      );
      const currentNode = this.emailNodes.find(
        (element) => element.id === this.localModel.email_node_id
      );
      const currentSequence = this.sequences.find(
        (element) => element.id === this.localModel.sequence_id
      );
      if (currentLink) {
        this.localModel.predata = {
          sequence: currentSequence.name,
          sequence_id: this.localModel.sequence_id,
          email_node: currentNode.name,
          email_node_id: this.localModel.email_node_id,
          email_link: currentLink.redirect_url,
          email_link_id: this.localModel.sequence_email_node_link_id,
        };
        this.localModel.predataname = `${currentSequence.name}, ${currentNode.name}, ${currentLink.redirect_url}`;
        this.pre_addbtn = true;
      }
    },

    automationModalClosed() {
      this.localModel.affiliateActionType = '0';
      this.localModel.commissiontierid = '';
      this.localModel.predataname = '';
      this.localModel.preoperation = '';
      this.localModel.postdataname = '';
      this.localModel.postoperation = '';
      this.localModel.postmembershipid = '';
      this.localModel.postaccesslevelid = '';
      this.localModel.pre_main_type = '';
      this.localModel.post_main_type = '';
      this.localModel.prefields = [];
      this.localModel.postfields = [];
      this.localModel.name = '';
      this.localModel.funnelid = '';
      this.localModel.productid = '';
      this.localModel.pricepointid = '';
      this.localModel.postfunnelid = '';
      this.localModel.postproductid = '';
      this.localModel.postpricepointid = '';
      this.localModel.pre_mainselect = '';
      this.localModel.post_mainselect = '';
      this.localModel.predata = '';
      this.localModel.postdata = '';
      this.pre_addbtn = false;
      this.post_addbtn = false;
      this.integrationType = '';
      this.localModel.integrationId = '';
      this.localModel.integration_config = '';
      this.localModel.broadcast_id = '';
      this.localModel.broadcast_link_id = '';
      this.localModel.sequence_id = '';
      this.localModel.email_node_id = '';
      this.localModel.sequence_email_node_link_id = '';
      this.$v.localModel.name.$reset();
    },

    closeAutomationCreateModal() {
      this.$emit('closeAutomationCreateModal');
    },

    async precategory(e) {
      this.showLoader();
      const self = this;
      self.pre_tags = [];

      try {
        const { data } = await axios.get('/mailtag', {params: { category: e.target.value },});
        if (data.length > 0) {
          self.pre_tags = data;
        }
        this.hideLoader();
      } catch(error) {
        self.pre_tags = [];
        this.hideLoader();

        // show error alert
        showRequestErrorAlert(error?.response?.data?.message);
      }
    },

    async postcategory(e) {
      this.showLoader();
      const self = this;
      self.post_tags = [];

      try {
        const { data } = await axios.get('/mailtag', {params: { category: e.target.value },});
        if (data.length > 0) {
          self.post_tags = data;
        }
        this.hideLoader();
      } catch(error) {
        self.post_tags = [];
        this.hideLoader();

        // show error alert
        showRequestErrorAlert(error?.response?.data?.message);
      }
    },

    async changepreselect(e) {
      this.pre_addbtn = false;
      this.localModel.predata = '';
      this.localModel.pre_main_type =
        e.target.options[e.target.options.selectedIndex].dataset.type;
      this.localModel.preoperation =
        e.target.options[e.target.options.selectedIndex].dataset.operation;
      if (
        this.localModel.pre_main_type === 'form' &&
        this.localModel.prefields &&
        this.localModel.prefields.length === 0
      ) {
        let actionIndex = 0;
        this.actions.forEach((ele) => {
          if (
            ele.dataType === 'groovesell-refund-order' ||
            ele.dataType === 'groovesell-cancel-subscription'
          ) {
            this.actions[actionIndex].disabled = true;
          }
          actionIndex += 1;
        });
        this.localModel.post_mainselect = '';
      } else {
        let actionIndex = 0;
        this.actions.forEach((ele) => {
          if (
            ele.dataType === 'groovesell-refund-order' ||
            ele.dataType === 'groovesell-cancel-subscription'
          ) {
            this.actions[actionIndex].disabled = false;
          }
          actionIndex += 1;
        });
      }
      if (
        this.localModel.pre_main_type === 'groovesell-purchase' ||
        this.localModel.pre_main_type === 'groovesell-abandon-cart' ||
        this.localModel.pre_main_type === 'groovesell-refund' ||
        this.localModel.pre_main_type === 'groovesell-cancel-subscription'
      ) {
        this.localModel.funnelid = '';
        this.localModel.productid = '';
        this.localModel.pricepointid = '';
        const groovesellUrl = window.config.apiUrl.substr(
          0,
          window.config.apiUrl.lastIndexOf('/')
        );

        // show loader
        this.showLoader();

        try {
          const result = await axios.get(`${groovesellUrl  }/groovesell/funnels-breakdown`);
          this.pre_funnels = result.data.funnels;
          
          // hide loader
          this.hideLoader();
        } catch(error) {
          this.pre_funnels = [];
          this.hideLoader();

          // show error alert
          showRequestErrorAlert(error?.response?.data?.message);
        }

      }
      if (
        this.localModel.pre_main_type === 'groovemail-opened-broadcast-email' ||
        this.localModel.pre_main_type === 'groovemail-clicked-link-broadcast-email'
      ) {
        this.broadcasts = [];
        this.broadcastLinks = [];
        this.localModel.broadcast_id = '';
        this.localModel.broadcast_link_id = '';
        await this.fetchBroadcastsData();
      }
      if (
        this.localModel.pre_main_type === 'groovemail-opened-sequence-email' ||
        this.localModel.pre_main_type === 'groovemail-clicked-link-sequence-email'
      ) {
        this.sequences = [];
        this.emailNodes = [];
        this.sequenceEmailLinks = [];
        this.localModel.sequence_id = '';
        this.localModel.email_node_id = '';
        this.localModel.sequence_email_node_link_id = '';
        await this.fetchSequencesData();
      }
    },

    async fetchBroadcastsData() {
      this.showLoader();
      try {
        const broadcastsData = await axios.get(`broadcast/list`);
        if (
          broadcastsData &&
          broadcastsData.data &&
          broadcastsData.data.data &&
          broadcastsData.data.data.length
        ) {
          this.broadcasts = broadcastsData.data.data;
        } else {
          this.broadcasts = [];
        }
        this.hideLoader();
      } catch(error) {
        this.broadcasts = [];
        this.hideLoader();

        // show error alert
        showRequestErrorAlert(error?.response?.data?.message);
      }
    },

    async fetchSequencesData() {
      this.showLoader();
      try {
        this.sequences = await Mailsequence.$get();
        this.hideLoader();
      } catch(error) {
        this.sequences = [];
        this.hideLoader();

        // show error alert
        showRequestErrorAlert(error?.response?.data?.message);
      }
    },

    async changepostselect(e) {
      // for integration
      this.integrationType = '';
      this.pluginId = '';
      this.componentConfigValues = [];
      this.localModel.integrationId = '';
      this.localModel.integration_config = '';

      this.post_addbtn = false;
      this.localModel.postdata = '';
      this.localModel.post_main_type =
        e.target.options[e.target.options.selectedIndex].dataset.type;
      this.localModel.postoperation =
        e.target.options[e.target.options.selectedIndex].dataset.operation;
      if (
        this.localModel.post_main_type === 'groovesell-refund-order' ||
        this.localModel.post_main_type === 'groovesell-cancel-subscription' ||
        this.localModel.post_main_type === 'groovesell-add-affiliate'
      ) {
        this.localModel.postfunnelid = '';
        this.localModel.postproductid = '';
        this.localModel.postpricepointid = '';
        const groovesellUrl = window.config.apiUrl.substr(
          0,
          window.config.apiUrl.lastIndexOf('/')
        );
        if (
          this.localModel.post_mainselect === this.$t('frontend_automations_actions_refund_a_purchase') ||
          this.localModel.post_mainselect === this.$t('frontend_automations_trigger_lead_cancel_a_subscription')
        ) {
          this.showLoader();
          try {
            const result = await axios.get(`${groovesellUrl  }/groovesell/funnels-breakdown`);
            this.post_funnels = result.data.funnels;
            this.hideLoader();
          } catch(error) {
            this.post_funnels = [];
            this.hideLoader();

            // show error alert
            showRequestErrorAlert(error?.response?.data?.message);
          }
        } else if (
          this.localModel.post_mainselect === this.$t('frontend_automations_actions_add_as_an_affiliate')
        ) {
          this.showLoader();
          try {
            const result = await axios.get(`${groovesellUrl  }/groovesell/fetch-commission-tiers`);
            this.post_funnels = result.data.funnels;
            this.hideLoader();
          } catch(error) {
            this.post_funnels = [];
            this.hideLoader();

            // show error alert
            showRequestErrorAlert(error?.response?.data?.message);
          }
        }
      } else if (
        this.localModel.post_mainselect === this.$t('frontend_automations_actions_add_a_membership')
      ) {
        this.showLoader();

        try {
          const groovememberUrl = window.config.apiUrl.substr(0, window.config.apiUrl.lastIndexOf('/'));
          const result = await axios.get(`${groovememberUrl}/groovemember/memberships`);
          // const result = await axios.get(
            // `${window.gdEnv.apiCoreUrl}/groovemember/memberships`
          // );
          this.post_memberships = result.data;
          this.hideLoader();
        } catch(error) {
          this.post_memberships = [];
          this.hideLoader();

          // show error alert
          showRequestErrorAlert(error?.response?.data?.message);
        }
      }
    },

    assignprename(e) {
      this.localModel.predataname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      this.pre_addbtn = true;
    },

    assignpostname(e) {
      this.localModel.postdataname =
        e.target.options[e.target.options.selectedIndex].dataset.name;
      this.post_addbtn = true;
    },

    addprefield() {
      switch (this.localModel.pre_mainselect) {
        case this.$t('frontend_automations_trigger_lead_purchased_a_product'):
        case this.$t('frontend_groovemail_automations_trigger_abandon_cart'):
        case this.$t('frontend_automations_trigger_lead_refunded_a_product'):
        case this.$t('frontend_automations_trigger_lead_cancel_a_subscription'):
          this.localModel.prefields.push({
            funnel_id: this.localModel.predata.funnel_id,
            product_id: this.localModel.predata.product_id,
            pricepoint_id: this.localModel.predata.pricepoint_id,
            funnel: this.localModel.predata.funnel,
            product: this.localModel.predata.product,
            pricepoint: this.localModel.predata.pricePoint,
            name: this.localModel.predataname,
            type: this.localModel.pre_main_type,
            action: this.localModel.pre_mainselect,
            operation: this.localModel.preoperation,
          });
          break;
        case this.$t('frontend_groovemail_leads_filter_opened_a_broadcast_option'):
          this.localModel.prefields.push({
            broadcast_id: this.localModel.predata.broadcast_id,
            broadcast: this.localModel.predata.broadcast,
            name: this.localModel.predataname,
            type: this.localModel.pre_main_type,
            action: this.localModel.pre_mainselect,
            operation: this.localModel.preoperation,
          });
          break;
        case this.$t('frontend_groovemail_leads_filter_clicked_a_link_option'):
          this.localModel.prefields.push({
            broadcast_id: this.localModel.predata.broadcast_id,
            broadcast: this.localModel.predata.broadcast,
            broadcast_link_id: this.localModel.predata.broadcast_link_id,
            broadcast_link: this.localModel.predata.broadcast_link,
            name: this.localModel.predataname,
            type: this.localModel.pre_main_type,
            action: this.localModel.pre_mainselect,
            operation: this.localModel.preoperation,
          });
          break;
        case this.$t('frontend_groovemail_automations_trigger_opened_email_from_sequence'):
          this.localModel.prefields.push({
            sequence: this.localModel.predata.sequence,
            sequence_id: this.localModel.predata.sequence_id,
            email_node: this.localModel.predata.email_node,
            email_node_id: this.localModel.predata.email_node_id,
            name: this.localModel.predataname,
            type: this.localModel.pre_main_type,
            action: this.localModel.pre_mainselect,
            operation: this.localModel.preoperation,
          });
          break;
        case this.$t('frontend_groovemail_automations_trigger_clicked_link_in_email_from_sequence'):
          this.localModel.prefields.push({
            sequence: this.localModel.predata.sequence,
            sequence_id: this.localModel.predata.sequence_id,
            email_node: this.localModel.predata.email_node,
            email_node_id: this.localModel.predata.email_node_id,
            email_link: this.localModel.predata.email_link,
            email_link_id: this.localModel.predata.email_link_id,
            name: this.localModel.predataname,
            type: this.localModel.pre_main_type,
            action: this.localModel.pre_mainselect,
            operation: this.localModel.preoperation,
          });
          break;
        default:
          this.localModel.prefields.push({
            id: this.localModel.predata,
            name: this.localModel.predataname,
            type: this.localModel.pre_main_type,
            action: this.localModel.pre_mainselect,
            operation: this.localModel.preoperation,
          });
          break;
      }

      this.initializePrefieldData();
    },

    initializePrefieldData() {
      this.localModel.predata = '';
      this.localModel.predataname = '';
      this.localModel.pre_main_type = '';
      this.localModel.pre_mainselect = '';
      this.localModel.preoperation = '';
      this.localModel.funnelid = '';
      this.localModel.productid = '';
      this.localModel.pricepointid = '';
      this.localModel.broadcast_id = '';
      this.localModel.broadcast_link_id = '';
      this.localModel.sequence_id = '';
      this.localModel.email_node_id = '';
      this.localModel.sequence_email_node_link_id = '';
      this.pre_products = [];
      this.pre_price_points = [];
      this.broadcasts = [];
      this.broadcastLinks = [];
      this.sequences = [];
      this.emailNodes = [];
      this.sequenceEmailLinks = [];
      this.pre_addbtn = false;
    },

    addpostfield() {
      if (
        this.localModel.post_mainselect ===
          this.$t('frontend_automations_actions_refund_a_purchase') ||
        this.localModel.post_mainselect ===
          this.$t('frontend_automations_trigger_lead_cancel_a_subscription')
      ) {
        this.localModel.postfields.push({
          funnel_id: this.localModel.postdata.funnel_id,
          product_id: this.localModel.postdata.product_id,
          pricepoint_id: this.localModel.postdata.pricepoint_id,
          funnel: this.localModel.postdata.funnel,
          product: this.localModel.postdata.product,
          pricepoint: this.localModel.postdata.pricePoint,
          name: this.localModel.postdataname,
          type: this.localModel.post_main_type,
          action: this.localModel.post_mainselect,
          operation: this.localModel.postoperation,
        });
      } else if (
        this.localModel.post_mainselect ===
        this.$t('frontend_automations_actions_add_as_an_affiliate')
      ) {
        if (this.localModel.affiliateActionType === '0') {
          this.localModel.postfields.push({
            funnel_id: this.localModel.postdata.funnel_id,
            funnel: this.localModel.postdata.funnel,
            name: this.localModel.postdataname,
            type: `${this.localModel.post_main_type  }-default`,
            action: this.localModel.post_mainselect,
            operation: this.localModel.postoperation,
          });
        } else if (this.localModel.affiliateActionType === '1') {
          this.localModel.postfields.push({
            funnel_id: this.localModel.postdata.funnel_id,
            funnel: this.localModel.postdata.funnel,
            product_id: this.localModel.postdata.product_id,
            product: this.localModel.postdata.product,
            pricepoint_id: this.localModel.postdata.pricepoint_id,
            pricePoint: this.localModel.postdata.pricePoint,
            commission_id: this.localModel.postdata.commission_id,
            commission: this.localModel.postdata.commission,
            name: this.localModel.postdataname,
            type: `${this.localModel.post_main_type  }-custom-tier`,
            action: this.localModel.post_mainselect,
            operation: this.localModel.postoperation,
          });
        }
      } else if (
        this.localModel.post_mainselect ===
        this.$t('frontend_automations_actions_add_a_membership')
      ) {
        this.localModel.postfields.push({
          membership_id: this.localModel.postmembershipid,
          secret_key: this.localModel.postaccesslevelid,
          membership: this.localModel.postdata.membership,
          access_level: this.localModel.postdata.access_level,
          name: this.localModel.postdataname,
          type: this.localModel.post_main_type,
          action: this.localModel.post_mainselect,
          operation: this.localModel.postoperation,
        });
      } else {
        this.localModel.postfields.push({
          id: this.localModel.postdata,
          name: this.localModel.postdataname,
          type: this.localModel.post_main_type,
          action: this.localModel.post_mainselect,
          operation: this.localModel.postoperation,
        });
      }
      this.initializePostFieldData();
    },

    initializePostFieldData() {
      this.localModel.postdata = '';
      this.localModel.postdataname = '';
      this.localModel.post_main_type = '';
      this.localModel.post_mainselect = '';
      this.localModel.postoperation = '';
      this.localModel.postmembershipid = '';
      this.localModel.postaccesslevelid = '';
      this.localModel.postfunnelid = '';
      this.localModel.postproductid = '';
      this.localModel.postpricepointid = '';
      this.localModel.commissiontierid = '';
      this.post_products = [];
      this.post_price_points = [];
      this.post_commmision_tiers = [];
      this.post_addbtn = false;
    },

    deletepre(option) {
      const index = this.localModel.prefields.indexOf(option);
      if (index === 0) {
        this.localModel.prefields = [];
      } else if (index > 0) {
        this.localModel.prefields.splice(index, 1);
      }
    },

    deletepost(option) {
      const index = this.localModel.postfields.indexOf(option);
      if (index > -1) {
        this.localModel.postfields.splice(index, 1);
      }
    },

    updatedAffiliateActionType() {
      this.localModel.postfunnelid = '';
      this.localModel.postdata = '';
      this.localModel.postdataname = '';
      this.localModel.postproductid = '';
      this.localModel.postpricepointid = '';
      this.localModel.commissiontierid = '';

      this.post_products = [];
      this.post_price_points = [];
      this.post_commmision_tiers = [];
      this.post_addbtn = false;
    },

    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },
  },
  components: {
    ConfigMenu,
    VuePerfectScrollbar,
    PlusIcon,
  },
};
</script>

<style lang="scss">
#automationmodel
  .bg-white.rounded-lg.shadow-2xl.relative.flex.flex-col.overflow-hidden {
  width: 800px !important;
  max-height: 98%;
}

select:focus {
  outline: none;
}

.integration-select {
  &-small {
    width: 40% !important;
  }
  
  &-large {
    width: 80% !important;
  }
  
  div span,
  &-config-menu div span {
    font-size: 14px;
    color: #545671;
    padding-right: 35px;
  }
  
  div.border-solid.border.rounded-lg.h-8.border-grey-200,
  &-config-menu
    div.border-solid.border.rounded-lg.h-8.border-grey-200 {
    border-radius: 4px;
    height: 38px;
    border: 1px #cccedc solid;
  }
  
  svg,
  &-config-menu svg {
    color: #545671;
  }
}

</style>

<style lang="scss" scoped>
.gm-legacy-automation {
  color: var(--gs-foreground);

  &__body,
  &__choice-controls,
  &__rule-item { min-width: 0; }

  ::v-deep .gm-legacy-automation__name-input {
    min-height: 2.75rem;
    height: auto;
  }
  ::v-deep .gm-legacy-automation__name-input input {
    height: 100% !important;
    min-height: 2.75rem !important;
    border: none !important;
  }

  &__choice-controls select {
    min-height: 2.75rem;
    line-height: 1.25;
  }

  &__choice-add { display: flex; align-items: flex-start; }
  &__add-rule {
    width: 2.75rem !important;
    min-width: 2.75rem !important;
    height: 2.75rem !important;
    min-height: 2.75rem !important;
  }

  &__rule-items { gap: 0.5rem 0; }
  &__rule-item { max-width: 100%; }
  &__rule-chip {
    align-items: center;
    max-width: 100%;
    min-height: 2.75rem;
    padding: 0.5rem 0.75rem !important;
    color: var(--gs-foreground) !important;
    background: var(--gs-surface-subtle) !important;
    border: 1px solid var(--gs-border);
  }
  &__rule-name {
    min-width: 0;
    overflow-wrap: anywhere;
  }
  &__rule-remove {
    display: inline-flex;
    flex: 0 0 2.75rem;
    align-items: center;
    justify-content: center;
    width: 2.75rem;
    min-width: 2.75rem;
    height: 2.75rem;
    min-height: 2.75rem;
    margin-left: 0.25rem !important;
    color: var(--gs-foreground);
  }
  &__and {
    flex: 0 0 2.75rem;
    min-width: 2.75rem;
    min-height: 2.75rem;
    color: var(--gs-foreground);
    background: var(--gs-surface);
    border-color: var(--gs-border-strong) !important;
  }

  &__footer {
    flex-wrap: wrap;
    gap: 0.75rem;
    margin-top: 1.5rem;
  }
  &__cancel,
  &__save {
    min-height: 2.75rem;
    padding: 0.625rem 1rem !important;
  }
  &__cancel {
    color: var(--gs-foreground) !important;
    background: var(--gs-surface) !important;
    border: 1px solid var(--gs-border-strong) !important;
    box-shadow: none !important;
  }
  &__save:not([disabled]):not(.disabled-btn) {
    color: var(--gs-primary-foreground) !important;
    background: var(--gs-primary) !important;
    border-color: var(--gs-primary) !important;
    box-shadow: var(--gs-primary-shadow) !important;
  }
  &__save:not([disabled]):not(.disabled-btn):hover {
    color: var(--gs-primary-foreground) !important;
    background: var(--gs-primary) !important;
    border-color: var(--gs-primary) !important;
  }
  &__save:not([disabled]):not(.disabled-btn):focus {
    outline: 2px solid var(--gs-primary);
    outline-offset: 2px;
  }

  @media (max-width: 40rem) {
    &__body { padding: 1rem !important; }
    &__choice-row {
      flex-direction: column;
      gap: 0.75rem;
    }
    &__choice-controls {
      flex: 0 0 auto;
      flex-direction: column;
      width: 100%;
      gap: 0.5rem;
    }
    &__choice-controls > div,
    &__choice-controls .flex > div,
    &__choice-controls .flex > select {
      width: 100% !important;
      margin-right: 0 !important;
      margin-left: 0 !important;
      padding-right: 0 !important;
    }
    &__choice-controls .flex {
      flex-direction: column;
      gap: 0.5rem;
    }
    &__choice-add { align-self: flex-end; }
    &__rule-item {
      flex-wrap: wrap;
      width: 100%;
    }
    &__rule-chip { width: 100%; }
    &__and {
      margin: 0.5rem 0 !important;
    }
    &__footer {
      justify-content: stretch;
      gap: 0.5rem;
    }
    &__cancel,
    &__save {
      flex: 1 1 8rem;
      margin-left: 0 !important;
    }
  }
}
</style>
